import styled from "@emotion/styled";
import { NumberField } from "@refinedev/antd";
import { Table, Typography } from "antd";
import { IInvoice } from "interfaces";

export const RecentInvoicesColumn = styled(Table.Column<IInvoice>)`
    vertical-align: top;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const Title = styled(Typography.Text)`
    font-size: 16px;
    word-break: inherit;
`;

export const InvoiceId = styled(Typography.Text)`
    cursor: pointer;
`;

export const Price = styled(NumberField)`
    white-space: nowrap;
`;
